import React from 'react';
import classnames from 'classnames';
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import styles from './styles.module.scss';

const ShumaType1Title = React.forwardRef(({}, ref) => {
  const context = useCompleteInspectionContext();
  return (
    <div className={classnames(styles.itemTitle, styles.bold)} ref={ref}>
      <span>{context.sectionNumbers.section10}</span>
      <span>. הצעת שווי</span>
    </div>
  );
});

export default ShumaType1Title;
